module.exports = __webpack_public_path__ + "img/t2.7ee38cd5.jpg";